/** @format */

/**
 * Global spacing throughout application will be multiples of fours.
 *
 * Example Usage in css => margin-bottom: Spacing.Two
 */
export enum Spacing {
  None = 0,
  OneQuarter = '1px',
  OneHalf = '2px',
  One = '4px',
  OneAndAHalf = '6px',
  Two = '8px',
  TwoAndAHalf = '10px',
  Three = '12px',
  Four = '16px',
  Five = '20px',
  Six = '24px',
  Seven = '28px',
  Eight = '32px',
  Nine = '36px',
  Ten = '40px',
  Eleven = '44px',
  Twelve = '48px',
  Thirteen = '52px',
  Fourteen = '56px',
  Fifteen = '60px',
  Sixteen = '64px',
}

export default Spacing;
